<div class="referral-panel" *ngIf="!!tenantId">
    <div class="referral-panel-glow"></div>

    <p class="referral-intro">¿Tienes un socio, familiar o conocido que lleve su negocio en Excel o en papel?</p>

    <h2 class="referral-title">Invita y gana ${{ referralCodeData?.rewardPerReferral ?? defaultReward }}.</h2>

    <div class="referral-reward-single">
        <div class="reward-big-amount">${{ referralCodeData?.rewardPerReferral ?? defaultReward }}</div>
        <div class="reward-big-label">te hacemos una transferencia de ${{ referralCodeData?.rewardPerReferral ?? defaultReward }}<br />por cada negocio que refieras</div>
    </div>

    <ol class="referral-steps">
        <li>
            <span class="step-number">1</span>
            <span class="step-text">Comparte tu código</span>
        </li>
        <li>
            <span class="step-number">2</span>
            <span class="step-text">Ellos se registran en FINA con tu link</span>
        </li>
        <li>
            <span class="step-number step-number-highlight">3</span>
            <span class="step-text">¡Te pagamos ${{ referralCodeData?.rewardPerReferral ?? defaultReward }} directamente!</span>
        </li>
    </ol>

    <div class="referral-info-box">Una vez que tu amigo se registre, el equipo de Fina se contactará contigo y recibirás tu pago ese mismo día.</div>

    <button type="button" class="whatsapp-btn" (click)="shareOnWhatsApp()" [disabled]="isLoading || !referralLink">
        <svg class="whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="currentColor"
                d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.05 1.51 5.74L2 22l4.49-1.6a9.86 9.86 0 0 0 5.55 1.7h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2zm0 1.99c4.36 0 7.92 3.55 7.92 7.92 0 4.36-3.56 7.92-7.92 7.92h-.01a7.9 7.9 0 0 1-4.03-1.1l-.29-.17-2.66.94.95-2.6-.19-.3a7.9 7.9 0 0 1-1.22-4.23c0-4.37 3.56-7.92 7.92-7.92zm-2.84 4.31c-.16 0-.42.06-.64.3-.22.24-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.16 1.7 2.6 4.13 3.64 2.02.86 2.43.69 2.87.65.44-.04 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.93-1.19-.71-.63-1.19-1.41-1.33-1.65-.14-.24-.02-.37.1-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.4-.54-.41-.14-.01-.3-.01-.46-.01z"
            />
        </svg>
        Compartir por WhatsApp
    </button>

    <button type="button" class="copy-link-field" (click)="copyReferralLink()" [disabled]="isLoading || !referralLink" [class.copied]="linkCopied" title="Copiar enlace de referido">
        <span class="copy-link-text">{{ referralLink || 'Generando tu enlace…' }}</span>
        <span class="copy-link-icon" aria-hidden="true">
            <svg *ngIf="!linkCopied" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" stroke-width="2" />
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <svg *ngIf="linkCopied" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </span>
    </button>

    <!-- Saldo acumulado (solo modo balance) -->
    <div class="referral-balance" *ngIf="referralCodeData?.paymentMode === 'balance'">
        <div class="balance-label">Tu saldo acumulado</div>
        <div class="balance-amount">${{ referralCodeData?.balanceInFavor | number : '1.2-2' }} {{ referralCodeData?.rewardCurrency }}</div>
        <div class="balance-hint">Se acreditará en tu próxima factura.</div>
    </div>

    <!-- Sección de pago móvil (solo modo transfer) -->
    <div class="payment-mobile-section" *ngIf="referralCodeData?.paymentMode === 'transfer'">
        <div class="payment-mobile-divider"></div>
        <div class="payment-mobile-header">
            <span class="payment-mobile-title">Tus datos de cobro</span>
            <span class="payment-mobile-hint">Para recibir tu pago por transferencia</span>
        </div>

        <!-- Sin datos: banner de alerta -->
        <ng-container *ngIf="!hasPaymentMobile && !isEditingPayment">
            <div class="payment-alert">
                <svg class="payment-alert-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                        d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <span>Registra tus datos de pago móvil para recibir tus recompensas por transferencia.</span>
            </div>
            <button type="button" class="payment-register-btn" (click)="startEditPayment()">Registrar datos de pago</button>
        </ng-container>

        <!-- Con datos: modo lectura -->
        <ng-container *ngIf="hasPaymentMobile && !isEditingPayment">
            <div class="payment-data-readonly">
                <div class="payment-data-row">
                    <span class="payment-data-label">Cédula</span>
                    <span class="payment-data-value">{{ referralCodeData?.paymentMobile?.cedula }}</span>
                </div>
                <div class="payment-data-row">
                    <span class="payment-data-label">Teléfono</span>
                    <span class="payment-data-value">{{ referralCodeData?.paymentMobile?.phone }}</span>
                </div>
                <div class="payment-data-row">
                    <span class="payment-data-label">Banco</span>
                    <span class="payment-data-value">{{ referralCodeData?.paymentMobile?.bank }}</span>
                </div>
            </div>
            <button type="button" class="payment-edit-btn" (click)="startEditPayment()">Editar datos</button>
        </ng-container>

        <!-- Formulario de edición -->
        <ng-container *ngIf="isEditingPayment">
            <form class="payment-form" #paymentFormRef="ngForm" (ngSubmit)="onSavePaymentMobile()" novalidate>
                <div class="payment-form-field">
                    <label class="payment-form-label" for="pmCedula">Cédula</label>
                    <input
                        id="pmCedula"
                        class="payment-form-input"
                        type="text"
                        inputmode="numeric"
                        placeholder="Ej: 12345678"
                        name="cedula"
                        [(ngModel)]="paymentForm.cedula"
                        required
                        [disabled]="isSavingPayment"
                    />
                </div>
                <div class="payment-form-field">
                    <label class="payment-form-label" for="pmPhone">Teléfono</label>
                    <input
                        id="pmPhone"
                        class="payment-form-input"
                        type="text"
                        inputmode="numeric"
                        placeholder="Ej: 04141234567"
                        name="phone"
                        [(ngModel)]="paymentForm.phone"
                        required
                        [disabled]="isSavingPayment"
                    />
                </div>
                <div class="payment-form-field">
                    <label class="payment-form-label" for="pmBank">Banco</label>
                    <input id="pmBank" class="payment-form-input" type="text" placeholder="Ej: Banco de Venezuela" name="bank" [(ngModel)]="paymentForm.bank" required [disabled]="isSavingPayment" />
                </div>

                <div class="payment-form-error" *ngIf="paymentSaveError">
                    {{ paymentSaveError }}
                </div>

                <div class="payment-form-actions">
                    <button type="submit" class="payment-save-btn" [disabled]="isSavingPayment">
                        <span *ngIf="!isSavingPayment">Guardar</span>
                        <span *ngIf="isSavingPayment">Guardando…</span>
                    </button>
                    <button type="button" class="payment-cancel-btn" (click)="cancelEditPayment()" [disabled]="isSavingPayment">Cancelar</button>
                </div>
            </form>
        </ng-container>
    </div>
</div>
